// extracted by mini-css-extract-plugin
module.exports = {"resizableBox":"resizable-shape-wrapper_resizableBox__1hAIE"};